import React from "react";
import { Input} from 'antd';

export default (props) =>{


  const id = JSON.stringify(props.id);
    const disabledFields = ["phnNo", "name"];

    return (
      <div style={{ marginTop: 20 }}>
        <div style={{ position: "relative" }}>
          <Input
            onChange={props.handleChange(id)}
            value={props.values[props.id]}
            placeholder={props.name}
            style={{
              width: "80%",
              height: 45,
              fontSize: 14,
              padding: 8,
              marginLeft: 15,
              marginRight: 15,
              borderWidth: 1,
              borderColor: "#000",
              borderRadius: 5,
            }}
            onBlur={props.handleBlur(id)}
            disabled={ props?.disableInput && disabledFields.includes(props.code) ? true : false}
          />
          {props.touched[props.id] && props.errors[props.id] && (
            <p
              style={{
                color: "red",
                fontSize: 12,
                textAlign: "left",
                position: "relative",
                marginLeft: 40,
                marginBottom: 20,
                marginTop: 10,
              }}
            >
              {props.errors[props.id]}
            </p>
          )}
        </div>
      </div>
    );
}
